import React from "react";
import ReactDOM from "react-dom";
import { Dialog } from "evergreen-ui";

const UserLeaveConfirmation = (message, callback) => {
  const container = document.createElement("div");
  container.setAttribute("custom-confirmation-navigation", "");
  document.body.appendChild(container);
  const closeModal = (callbackState) => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    callback(callbackState);
  };
  ReactDOM.render(
    <Dialog
      width="430px"
      minHeightContent="75px"
      topOffset="250px"
      cancelLabel="Cancel"
      confirmLabel="Confirm"
      isShown={true}
      onCacel={() => closeModal(false)}
      onConfirm={() => closeModal(true)}
      title="Please Confirm:"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEscapePress={false}
    >
      {message}
    </Dialog>,
    container
  );
};
export default UserLeaveConfirmation;
